import { clone, cloneDeep, isEmpty, isNil } from 'lodash';
import uuid from 'uuid';

export default {

  methods: {
    reloadPage(force = false) {
      if (force || (this.$route.meta || {}).reload) {
        const dest = {
          name: clone(this.$route.name),
          params: cloneDeep(this.$route.params || {}),
          path: clone(this.$route.path),
          meta: cloneDeep(this.$route.meta || {}),
          query: {
            ...(cloneDeep(this.$route.query) || {}),
            reload: uuid.v4(),
          },
        };
        return this.$router.replace(dest);
      } else {
        return Promise.reject(new Error('reload not allowed for page'));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ReloadPageMixin.js